import { CircularProgress } from "@suraasa/placebo-ui"
import { DeliveryMode } from "api/resources/learningItems/types"
import ErrorPage from "components/ErrorPage"
import { useEffect } from "react"
import { useEnrollments } from "utils/hooks/useEnrollments"

const legacy = "https://assets.suraasa.com/lms/pgctl-learner-handbook/1.0.pdf"
const starter =
  "https://assets.suraasa.com/lms/pgctl-learner-handbook/starter.pdf"
const professional =
  "https://assets.suraasa.com/lms/pgctl-learner-handbook/professional.pdf"
const executive =
  "https://assets.suraasa.com/lms/pgctl-learner-handbook/executive.pdf"
const tdc =
  "https://assets.suraasa.com/lms/pgctl-learner-handbook/executive-tdc.pdf"

const LearnerHandbook = () => {
  const {
    pgctl: { isPGCTLUser, deliveryMode },
  } = useEnrollments()

  useEffect(() => {
    if (!isPGCTLUser || deliveryMode === undefined) return

    const url = (() => {
      switch (deliveryMode) {
        case DeliveryMode.TDC:
          return tdc
        case DeliveryMode.EXECUTIVE:
          return executive
        case DeliveryMode.PROFESSIONAL:
          return professional
        case DeliveryMode.STARTER:
          return starter
        case DeliveryMode.LIVE_INSTRUCTOR_LED:
        case DeliveryMode.SELF_PACED:
        case null:
          return legacy
      }
    })()

    if (url) window.location.replace(url)
  }, [isPGCTLUser, deliveryMode])

  if (isPGCTLUser === undefined || deliveryMode === undefined) {
    return (
      <div className="flex items-center justify-center p-5">
        <CircularProgress />
      </div>
    )
  }

  if (!isPGCTLUser) {
    return <ErrorPage errorStatus={404} />
  }

  return (
    <div className="flex items-center justify-center p-5">
      <CircularProgress />
    </div>
  )
}

export default LearnerHandbook
